import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import store from './app/store';
import LanguageProvider from './features/LanguageProvider/LanguageProvider.container';
import history from './app/history';
import App from './features/App/App.container';
import {
  AzureAD,
  AuthenticationState,
  IAzureADFunctionProps,
} from 'react-aad-msal';
import {
  authProvider,
  authProviderDefault,
  config,
} from './providers/auth-provider';
import { SnackbarProvider } from 'notistack';
import { SnackbarUtilsConfigurator } from './helpers/Snackbar.helper';

const unauthenticatedFunction = () => (
  <AzureAD provider={authProvider(config('b2c_1_reset'))}>
    {({
      login,
      authenticationState,
    }: IAzureADFunctionProps): React.ReactElement | void => {
      switch (authenticationState) {
        default:
          login();
          return <h1>Loading...</h1>;
      }
    }}
  </AzureAD>
);

ReactDOM.render(
  <Provider store={store}>
    <LanguageProvider>
      <ConnectedRouter history={history}>
        <SnackbarProvider
          autoHideDuration={2500}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        >
          <SnackbarUtilsConfigurator />
          <AzureAD provider={authProviderDefault} forceLogin={true}>
            {({
              login,
              logout,
              authenticationState,
              error,
              accountInfo,
            }: IAzureADFunctionProps): React.ReactElement | void => {
              switch (authenticationState) {
                case AuthenticationState.Authenticated:
                  return <App />;
                case AuthenticationState.Unauthenticated:
                  console.log(error);
                  if (!accountInfo && error) {
                    if (error.errorMessage.includes('AADB2C90118')) {
                      return unauthenticatedFunction();
                    }
                    if (error.errorMessage.includes('AADB2C90091')) {
                      login();
                    }
                  }
                  return <div>Not authorized</div>;
                case AuthenticationState.InProgress:
                  return <p>Authenticating...</p>;
              }
            }}
          </AzureAD>
        </SnackbarProvider>
      </ConnectedRouter>
    </LanguageProvider>
  </Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
